import { Typography } from '@mui/material';
import { useStudioUnauthenticatedContext } from '../../context/StudioContext';

export const StudioFooterStudioVersion = () => {
  const { portalVersion } = useStudioUnauthenticatedContext();

  return (
    <Typography variant="caption" color="text.secondary">
      Studio {portalVersion}
    </Typography>
  );
};
